import { TypographyVariant } from "../../../constants/typography";
import { useTranslation } from "react-i18next";
import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./ActivateQrPopup.style";
import { QRCodeCanvas } from "qrcode.react";
import { PageRoutes } from "../../../constants/routes";

type IActivateQrPopup = {
  onClose?: () => void;
  activateLink: string;
};

const ActivateQrPopup: React.FC<IActivateQrPopup> = (props) => {
  const { onClose, activateLink } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  const isProController = !activateLink?.startsWith(
    import.meta.env.VITE_APP_URL,
  );
  const isSubscription = activateLink?.includes(PageRoutes.Subscription);

  const title = isProController
    ? t("ActivateQrPopup_Get It Now")
    : isSubscription
    ? t("ActivateQrPopup_Manage Your Subscription")
    : t("ActivateQrPopup_Scan QR to Subscribe");

  const description = isProController
    ? t("ActivateQrPopup_Please scan the QR code to view on mobile.")
    : isSubscription
    ? t(
        "ActivateQrPopup_Scan this QR code with your phone to subscribe, upgrade, or update your plan.",
      )
    : t(
        "ActivateQrPopup_Please scan the QR code to complete your subscription.",
      );

  return (
    <Dialog
      open={!!activateLink}
      title={title}
      mainAction={{
        text: t("ActivateQrPopup_Ok"),
        onClick: onClose,
        "data-gamepad": "default-selected",
        "data-button-sound": "back",
        id: "close-dialog",
      }}
      className={classes.contentDialog}
    >
      <Typography variant={TypographyVariant.HeadingH3Bold}>{title}</Typography>
      <Typography
        variant={TypographyVariant.BodyB3Regular}
        className={classes.desc}
      >
        {description}
      </Typography>
      <QRCodeCanvas
        value={activateLink}
        size={160}
        level="L"
        marginSize={3}
        className={classes.qrCode}
      />
    </Dialog>
  );
};
export default ActivateQrPopup;
